import { ApiBase } from "@/api/ApiBase";

export interface ContaBancariaResumo {
  codigo: string;
  titular: string;
  numero: string;
  iban: string;
  estado: "Activo" | "Inactivo";
  dataCriacao: string;
  banco: string;
}

export interface BancoResumo {
  id: number;
  nome: string;
  sigla: string;
  codigo: string;
}

export interface DadosContaBancariaForm {
  titular: string;
  numero: string;
  iban: string;
  estado: "Activo" | "Inactivo";
  bancoId: number;
}

export interface EditarApagarContaBancariaResponse {
  msg: string;
  tipo: "sucesso" | "erro";
}

export class ContasBancariasApi extends ApiBase {
  listar(): Promise<ContaBancariaResumo[]> {
    return this.http.put<ContaBancariaResumo[]>(
      "/api/comerciante/conta-bancaria/lista-by-comerciante",
    );
  }

  listarBancos(): Promise<BancoResumo[]> {
    return this.http.put<BancoResumo[]>(
      "/api/comerciante/conta-bancaria/lista-bancos",
    );
  }

  private construirDados(
    dados: DadosContaBancariaForm,
    codigoExistente?: string,
  ): Record<string, string> {
    const params: Record<string, string> = {
      titular: dados.titular,
      numero: dados.numero,
      iban: dados.iban,
      estado: dados.estado,
      "banco.id": String(dados.bancoId),
    };
    if (codigoExistente) params.codigo = codigoExistente;
    return params;
  }

  adicionar(
    dados: DadosContaBancariaForm,
  ): Promise<EditarApagarContaBancariaResponse> {
    return this.http.post<EditarApagarContaBancariaResponse>(
      "/api/comerciante/conta-bancaria/add",
      this.construirDados(dados),
    );
  }

  editar(
    codigo: string,
    dados: DadosContaBancariaForm,
  ): Promise<EditarApagarContaBancariaResponse> {
    return this.http.post<EditarApagarContaBancariaResponse>(
      "/api/comerciante/conta-bancaria/edit",
      this.construirDados(dados, codigo),
    );
  }

  apagar(codigo: string): Promise<EditarApagarContaBancariaResponse> {
    return this.http.post<EditarApagarContaBancariaResponse>(
      "/api/comerciante/conta-bancaria/delete",
      { codigo },
    );
  }
}
